export default "__VITE_ASSET__BLXt82hB__"